module.exports = __webpack_public_path__ + "static/media/BOTON WEB_Danza RO.f85a7504.png";